import { ScrollView } from "react-native";

/* -----------------Child components--------------- */
import { AccountListItem } from "components";

import { Box } from "@memorang/ui";
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";
/* -----------------Types--------------- */
import type { Section } from "../types";

type Props = {
	sections: Section[];
};

const AccountView = ({ sections }: Props) => {
	return (
		<ScrollView>
			<Box gap={16}>
				{sections.map(({ sectionTitle, items }) => (
					<Box key={sectionTitle} gap={8}>
						<CustomListSubheaderContainer enableGutters>
							{sectionTitle}
						</CustomListSubheaderContainer>
						{items.map((view) => (
							<AccountListItem key={view.title} {...view} />
						))}
					</Box>
				))}
			</Box>
		</ScrollView>
	);
};

export default AccountView;
